import { useQuery } from '@tanstack/react-query'
import { fetchChatConfig } from '../../../api/chat/chat'
import { ChatConfig } from '../../../modules/chat/types/chat'

export const useChatConfig = () =>
  useQuery<ChatConfig>({
    queryKey: ['chat', 'config'],
    queryFn: fetchChatConfig,
    staleTime: 60 * 60 * 1000
  })
